<app-menu-stick *ngIf="data.newCoverButton && data.newCoverButton?.length" [items]="data.newCoverButton" [venue]="data"></app-menu-stick>
<section class="subheader" *ngIf="data">
  <img onerror="this.src='./assets/img/default.png'" *ngIf="!isMob && data?.newCover?.path" class=" w-100 img-desk"
    [src]="data?.newCover?.path">
  <img onerror="this.src='./assets/img/default.png'" *ngIf="isMob && data?.newCover?.pathMobile" class=" w-100 img-mob"
    [src]="data?.newCover?.pathMobile ">



  <img *ngIf="isMob && !data?.newCover?.pathMobile && !data?.newCover?.video_path" class=" w-100 img-mob"
    src="./assets/img/default.png">
  <img *ngIf="!isMob && !data?.newCover?.path && !data?.newCover?.video_path" class=" w-100 img-desk"
    src="./assets/img/default.png">

  <video #videoPlayer autoplay muted playsinline loop *ngIf="!isMob && data?.newCover?.video_path"
    class="w-100 video-desk">
    <source [src]="createLink(data?.newCover?.video_path)" type="video/mp4">
  </video>
  <video #videoPlayerMob autoplay muted playsinline loop *ngIf="isMob && data?.newCover?.video_pathMobile"
    class="w-100 video-mob">
    <source [src]="createLink(data?.newCover?.video_pathMobile)" type="video/mp4">
  </video>
  <div *ngIf="data?.newCover?.check_capa && !isMob " class="overlay"></div>
  <div *ngIf="data?.newCover?.check_capa && isMob" class="overlay"></div>
  <div class="row">
    <div class="col-lg-12">
      <div class="container-carousel-header w-100 d-flex justify-content-center align-items-center">
        <ng-container *ngFor="let boton of data?.coverButton">
          <div id="boton-portada" *ngIf="boton.estado" class="carousel-cell-header  container-boton "
            style="    min-width: 15% !important">
            <a target="_blank" [href]="boton.link" [style.background]="boton.background" class="boton pointer zoomIn"
              style="right:auto !important" [style.width]="boton.width_button + 'px'">
              <span class="nunito-regular">
                {{boton.label}}
              </span>
            </a>
          </div>
        </ng-container>
        <div
          *ngIf="showContactButton"
          class="carousel-cell-header container-boton contact-button-container">
          <button
            type="button"
            class="boton contact-button pointer zoomIn"
            [style.background-color]="contactButtonColor"
            (click)="openContactModal()">
            <span class="nunito-regular">CONTACTO</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="texto-s container">
    <h1 class="blanco bold">{{title}}</h1>
  </div>
</section>
